import { useMemo } from "react";

import * as COLUMNS_AVAILABLE from "b2b/components/zadosti-grid-columns/columnsAvailable";

export default function useColumns() {
  const columns = [
    COLUMNS_AVAILABLE.zdrojNazev(),
    COLUMNS_AVAILABLE.termin(),
    COLUMNS_AVAILABLE.kolize(),
    COLUMNS_AVAILABLE.fixni(),
    COLUMNS_AVAILABLE.zadavatelZakaznikNazev(),
    COLUMNS_AVAILABLE.doplnkoveSluzby(),
    COLUMNS_AVAILABLE.datumVytvoreni(),
    COLUMNS_AVAILABLE.stav()
  ];
  return useMemo(() => [columns], []);
}
